import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Crown, LogOut, User } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0A0A]/70 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo-link" className="flex items-center gap-2.5 group">
          <Crown className="w-5 h-5 text-[#C5A059] group-hover:rotate-6 transition-transform" />
          <div className="flex flex-col leading-none">
            <span className="font-heading text-lg tracking-tight text-white">
              BLACK<span className="text-[#C5A059]">·</span>SAPPHIRE
            </span>
            <span className="hidden sm:block text-[8px] tracking-[0.4em] uppercase text-white/40 mt-1">
              The Quiet Standard
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/" data-testid="nav-link-home" end className="gold-link text-xs uppercase tracking-[0.2em]">
            Home
          </NavLink>
          <NavLink to="/book" data-testid="nav-link-book" className="gold-link text-xs uppercase tracking-[0.2em]">
            Reserve
          </NavLink>
          {user && (
            <NavLink to="/trips" data-testid="nav-link-trips" className="gold-link text-xs uppercase tracking-[0.2em]">
              My Trips
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span data-testid="navbar-user-name" className="hidden sm:flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/70">
                <User className="w-3.5 h-3.5 text-[#C5A059]" /> {user.name?.split(" ")[0]}
              </span>
              <button
                data-testid="navbar-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-xs uppercase tracking-[0.2em] text-white/70 hover:text-[#C5A059] flex items-center gap-1.5 transition-colors"
              >
                <LogOut className="w-3.5 h-3.5" /> Sign Out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="navbar-login-link"
                className="hidden sm:inline-block text-xs uppercase tracking-[0.2em] text-white/70 hover:text-[#C5A059] transition-colors"
              >
                Sign In
              </Link>
              <Link
                to="/register"
                data-testid="navbar-register-btn"
                className="bg-white text-[#0A0A0A] hover:bg-[#C5A059] hover:text-white transition-colors duration-300 px-5 py-2.5 text-xs uppercase tracking-[0.2em] font-medium"
              >
                Reserve
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
